import { render, staticRenderFns } from "./OrderDetailHeader.vue?vue&type=template&id=21fda2b0&scoped=true"
import script from "./OrderDetailHeader.vue?vue&type=script&lang=js"
export * from "./OrderDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailHeader.vue?vue&type=style&index=0&id=21fda2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fda2b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
